"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphComponentEditor = exports.ParagraphsComponentCreator = exports.ParagraphComponentCreator = exports.ParagraphComponentWebsiteRender = exports.ParagraphComponentRender = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const structure_1 = require("./structure");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
// import { BsTypeBold, BsTypeH2, BsTypeH1 } from 'react-icons/bs'
const ContentEditableToolBar_1 = __importDefault(require("../../dashboard/components/ContentEditableToolBar"));
const helpers_1 = require("../helpers");
const URLs_1 = require("../../dashboard/utility/URLs");
function ParagraphComponentRender(props) {
    var _a, _b, _c, _d;
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const render = props.render;
    const className = props.className;
    switch (render) {
        case 'original':
            return react_1.default.createElement("div", { dir: originalDir, style: component.style, className: className + ' my-2' }, (0, html_react_parser_1.default)((_a = component.original) !== null && _a !== void 0 ? _a : ''));
        case 'translated':
            return react_1.default.createElement("div", { dir: translatedDir, style: component.style, className: className + ' my-2' }, (0, html_react_parser_1.default)((_b = component.translated) !== null && _b !== void 0 ? _b : ''));
        case 'both':
            return react_1.default.createElement("div", { style: component.style, className: className + ' my-2' },
                react_1.default.createElement("div", { dir: originalDir }, (0, html_react_parser_1.default)((_c = component.original) !== null && _c !== void 0 ? _c : '')),
                react_1.default.createElement("div", { dir: translatedDir }, (0, html_react_parser_1.default)((_d = component.translated) !== null && _d !== void 0 ? _d : '')));
    }
}
exports.ParagraphComponentRender = ParagraphComponentRender;
function ParagraphComponentWebsiteRender(props) {
    var _a, _b, _c, _d, _e;
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const render = props.render;
    const className = props.className;
    // console.log('className', className)
    switch (render) {
        case 'original':
            return react_1.default.createElement("div", { dir: originalDir, style: component.style, className: className + ' my-2' }, (0, html_react_parser_1.default)((_a = component.original) !== null && _a !== void 0 ? _a : ''));
        case 'translated':
            return react_1.default.createElement("div", { className: 'mx-auto my-2' }, component.translated ?
                react_1.default.createElement("div", { dir: translatedDir, style: component.style, className: className }, (0, html_react_parser_1.default)((_b = component.translated) !== null && _b !== void 0 ? _b : ''))
                :
                    react_1.default.createElement("div", { className: className, dir: originalDir, style: component.style }, (0, html_react_parser_1.default)((_c = component.original) !== null && _c !== void 0 ? _c : '')));
        case 'both':
            return react_1.default.createElement("div", { style: component.style },
                react_1.default.createElement("div", { dir: originalDir, className: className + ' my-2' }, (0, html_react_parser_1.default)((_d = component.original) !== null && _d !== void 0 ? _d : '')),
                react_1.default.createElement("div", { dir: translatedDir, className: className + ' my-2' }, (0, html_react_parser_1.default)((_e = component.translated) !== null && _e !== void 0 ? _e : '')));
    }
}
exports.ParagraphComponentWebsiteRender = ParagraphComponentWebsiteRender;
function ParagraphComponentCreator(props) {
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState('');
    const [translated, settranslated] = react_1.default.useState('');
    const [style, setstyle] = react_1.default.useState({});
    return react_1.default.createElement("div", { className: 'my-3 bg-white rounded p-2' },
        react_1.default.createElement(ContentEditableToolBar_1.default, null),
        react_1.default.createElement("div", { className: "m-2" },
            react_1.default.createElement("div", { className: 'p-3 border rounded', style: style, contentEditable: true, onInput: e => {
                    const input = e.target;
                    // console.log('onInput innerHTML', e.target.innerHTML);
                    setoriginal(input.innerHTML);
                    dispatch((0, structure_1.paragraphObject)(input.innerHTML, translated, style));
                } })),
        react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement("div", { className: 'p-3 border rounded', style: style, contentEditable: true, onInput: e => {
                    const input = e.target;
                    console.log('onInput textContent', input.innerHTML);
                    settranslated(input.innerHTML);
                    dispatch((0, structure_1.paragraphObject)(original, input.innerHTML, style));
                } })));
}
exports.ParagraphComponentCreator = ParagraphComponentCreator;
function ParagraphsComponentCreator(props) {
    const dispatch = props.dispatch;
    // const [paragraphs, setparagraphs] = React.useState([])
    const [style, setstyle] = react_1.default.useState({});
    return react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement("div", { className: "mb-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", style: style, onChange: (e) => {
                    let paragraphs = [];
                    e.target.value.split('\n').forEach((str, index) => {
                        if (str.length)
                            paragraphs.push((0, structure_1.paragraphObject)(str, '', style));
                    });
                    // console.log('paragraphs', paragraphs)
                    // setparagraphs(paragraphs)
                    dispatch(paragraphs);
                } })));
}
exports.ParagraphsComponentCreator = ParagraphsComponentCreator;
function ParagraphComponentEditor(props) {
    const component = props.component;
    const dispatch = props.dispatch;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const [original, setoriginal] = react_1.default.useState(component.original);
    const [translated, settranslated] = react_1.default.useState(component.translated);
    const [style, setstyle] = react_1.default.useState(component.style);
    const [translatedScrollHeight, settranslatedScrollHeight] = react_1.default.useState(100);
    const [originalScrollHeight, setoriginalScrollHeight] = react_1.default.useState(100);
    let originalDiv = react_1.default.createRef();
    let translatedDiv = react_1.default.createRef();
    react_1.default.useEffect(() => {
        originalDiv.current.innerHTML = component.original;
        translatedDiv.current.innerHTML = component.translated;
        setoriginalScrollHeight(originalDiv.current.scrollHeight);
        settranslatedScrollHeight(translatedDiv.current.scrollHeight);
    }, []);
    return (react_1.default.createElement("div", { className: 'my-2' },
        react_1.default.createElement("div", { className: 'd-flex flex-wrap justify-content-around m-1' },
            react_1.default.createElement(ContentEditableToolBar_1.default, null),
            react_1.default.createElement("button", { className: 'btn btn-success d-flex', onClick: e => {
                    (0, helpers_1.ApiCallHandler)(() => URLs_1.Api.translate({
                        text: original,
                        target: 'ar',
                    }), (resData) => {
                        var _a;
                        translatedDiv.current.innerHTML = resData.text;
                        settranslated(resData.text);
                        settranslatedScrollHeight((_a = translatedDiv.current) === null || _a === void 0 ? void 0 : _a.scrollHeight);
                        dispatch((0, structure_1.paragraphObject)(original, resData.text, style));
                    }, 'translate to arabic', true);
                } },
                react_1.default.createElement("i", { className: "bi bi-translate mx-2 text-white" }),
                react_1.default.createElement("div", { className: 'text-white' }, "\u062A\u0631\u062C\u0645\u0629 \u0625\u0644\u0649 \u0627\u0644\u0639\u0631\u0628\u064A\u0629"))),
        react_1.default.createElement("div", { className: 'p-3 border rounded', style: Object.assign(Object.assign({}, style), { height: originalScrollHeight, overflowY: 'scroll' }), dir: originalDir, contentEditable: true, onInput: e => {
                const input = e.target;
                // console.log('onInput innerHTML', e.target.innerHTML);
                setoriginal(input.innerHTML);
                setoriginalScrollHeight(input.scrollHeight);
                dispatch((0, structure_1.paragraphObject)(input.innerHTML, translated, style));
            }, ref: originalDiv }),
        react_1.default.createElement("div", { className: 'p-3 border rounded', style: Object.assign(Object.assign({}, style), { height: translatedScrollHeight, overflowY: 'scroll' }), dir: translatedDir, contentEditable: true, onInput: e => {
                const input = e.target;
                // console.log('onInput innerHTML', e.target.innerHTML);
                settranslated(input.innerHTML);
                settranslatedScrollHeight(input.scrollHeight);
                dispatch((0, structure_1.paragraphObject)(original, input.innerHTML, style));
            }, ref: translatedDiv })));
}
exports.ParagraphComponentEditor = ParagraphComponentEditor;
